export default __webpack_public_path__ + "static/media/exportorders.8c92cab2.svg";